import slide1 from '../images/booth/slide1.jpg'
import slide2 from '../images/booth/slide2.jpg'
import slide3 from '../images/booth/slide3.jpg'
import slide4 from '../images/booth/slide4.jpg'

export default {
  info: {
    css: `
      top: 2%;
      left: 0%;
      right: 79%;
      bottom: 27.5%;
    `,
  },
  video: {
    videos: [
      {
        id: 1,
        name: "Wiley 36-month LipiDiDiet(LDD) Clinical Trial",
        url: "https://player.vimeo.com/video/525644895",
      },
      {
        id: 2,
        name: "Fortasyn Connect Mode of Action",
        url: "https://player.vimeo.com/video/525644717",
      },
      {
        id: 3,
        name: "Dr Keith's Souvenaid Journey",
        url: "https://player.vimeo.com/video/525644611",
      },
    ],
    css: `
      top: 2%;
      left: 27%;
      right: 53%;
      bottom: 27.5%;
    `,
  },
  image: {
    images: [
      {
        id: 1,
        url: slide1,
      },
      {
        id: 2,
        url: slide2,
      },
      {
        id: 3,
        url: slide3,
      },
      {
        id: 4,
        url: slide4,
      },
    ],
    css: `
      top: 2%;
      left: 53%;
      right: 26.5%;
      bottom: 27.5%;
    `,
  },
  namecard: {
    css: `
      top: 2%;
      left: 79%;
      right: 0.5%;
      bottom: 27.5%;
    `,
  },
}